import { gaTracking, getCurrentPageLocation, normalizeString } from "../../../lib/ga";

/**
 * Tracks search result view events
 * @param searchTerm - The search query entered by the user
 * @param searchResults - Number of results returned
 */
export const insuranceSearchSubmitTracker = (searchTerm: string, searchResults: number): void => {
  gaTracking({
    event: "view_search_results",
    event_parameters: {
      page_location: getCurrentPageLocation(),
      search_term: normalizeString(searchTerm) ?? "",
      search_results: searchResults,
    },
  });
};

/**
 * Tracks clicks on search results
 * @param searchTerm - The search query that produced the results
 * @param searchResults - Total number of results
 * @param resultTitle - Title of the clicked result
 */
export const insuranceSearchResultClickTracker = (
  searchTerm: string,
  searchResults: number,
  resultTitle: string,
): void => {
  gaTracking({
    event: "select_search_results",
    event_parameters: {
      page_location: getCurrentPageLocation().split("?")[0],
      search_term: normalizeString(searchTerm) ?? "",
      search_results: searchResults,
      selected_search_result: normalizeString(resultTitle),
    },
  });
};
